import { render, staticRenderFns } from "./InvoicePaymentTable.vue?vue&type=template&id=b1401376"
import script from "./InvoicePaymentTable.vue?vue&type=script&lang=ts"
export * from "./InvoicePaymentTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports